import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityNotice = () => {
  return (
    <div className="mt-8 p-4 bg-muted/50 border border-border rounded-lg">
      <div className="flex items-start space-x-3">
        <Icon name="Shield" size={16} className="text-primary mt-0.5 flex-shrink-0" />
        <div className="text-xs text-muted-foreground space-y-1">
          <p className="font-medium">Aviso de Seguridad:</p>
          <p>
            Este sistema está protegido y monitoreado. El acceso no autorizado está prohibido.
            Después de 3 intentos fallidos, la cuenta será bloqueada temporalmente.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SecurityNotice;